function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-1-a",
  width: 70,
  height: 70,
  rx: 24
}), React.createElement("linearGradient", {
  id: "avatar-1-d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7B186"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFC299"
})), React.createElement("path", {
  id: "avatar-1-c",
  d: "M25.12 36.396c-4.186 3.019-8.373 5.433-12.56 5.433-4.186 0-8.373-2.414-12.56-5.433 3.451-1.04 5.201-2.595 5.251-4.662l-.005-1.875a4508.009 4508.009 0 0 0-.035-10.122c-3.273-4.206-2.07-9.136-1.045-9.013C5.425 10.875 16.32.628 18.408.104c2.09-.525 7.398 1.17 8.311 5.895.914 4.725 1.295 16.636-2.17 21.392-.985 1.353-2.538 1.882-4.657 1.587a223.81 223.81 0 0 1-.024 2.665c.027 2.161 1.778 3.713 5.253 4.753z"
}), React.createElement("linearGradient", {
  id: "avatar-1-f",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})), React.createElement("linearGradient", {
  id: "avatar-1-g",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})), React.createElement("linearGradient", {
  id: "avatar-1-i",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#806A6A"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#665654"
})), React.createElement("path", {
  id: "avatar-1-h",
  d: "M4.322 1.136L5.46 22.038H0L1.137 1.136C1.845.379 2.377 0 2.73 0c.354 0 .885.379 1.592 1.136z"
}), React.createElement("path", {
  id: "avatar-1-j",
  d: "M4.582 5.383L1.004 3.318l.133-2.182C1.845.379 2.377 0 2.73 0c.354 0 .885.379 1.592 1.136l.26 4.247z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "avatar-1-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-1-a"
})), React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-1-a"
}), React.createElement("g", {
  mask: "url(#avatar-1-b)"
}, React.createElement("path", {
  d: "M3.5 7h63v63h-63z"
}), React.createElement("g", {
  transform: "matrix(-1 0 0 1 47.858 12.022)"
}, React.createElement("mask", {
  id: "avatar-1-e",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-1-c"
})), React.createElement("use", {
  fill: "url(#avatar-1-d)",
  xlinkHref: "#avatar-1-c"
}), React.createElement("path", {
  fill: "#FC9F6A",
  fillRule: "nonzero",
  d: "M19.868 28.975c-3.35-.377-6.09-1.283-8.221-2.716 2.436 3.018 5.176 4.829 8.221 5.433v-2.717z",
  mask: "url(#avatar-1-e)"
})), React.createElement("path", {
  fill: "url(#avatar-1-f)",
  fillRule: "nonzero",
  d: "M4.654 23.43C3.081 19.677-3.224 12.038 2.211 7.284c1.827-8.828 11.92-7.85 18.658-5.814 4.527 1.37 7.947 4.075 8.678 2.038 4.567 3.776 2.28 7.47-.731 8.53-2.733.962-7.354 1.924-15.211 1.019-1.404-.162-1.11 4.099-1.86 4.56-1.125.69-1.998-3.655-5.083-2.35-3.085 1.305-1.254 7.355 2.057 7.355 1.142 0 1.713 3.111-1.37 4.583-2.238 1.09-1.672-1.34-2.695-3.777z",
  transform: "matrix(-1 0 0 1 48.973 8.4)"
}), React.createElement("g", null, React.createElement("path", {
  fill: "url(#avatar-1-g)",
  fillRule: "nonzero",
  d: "M51.188 11.202c1.443 2.932 2.58 7.779 3.412 14.54H0c.831-6.762 1.969-11.609 3.413-14.54 1.443-2.93 6.38-5.756 14.81-8.474 6.987 2.726 11.263 2.725 18.148-.002 8.434 2.72 13.373 5.545 14.816 8.476z",
  transform: "translate(7.7 44.1)"
}), React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(32.27 47.28)"
}, React.createElement("use", {
  fill: "url(#avatar-1-i)",
  xlinkHref: "#avatar-1-h"
}), React.createElement("use", {
  fill: "#645050",
  xlinkHref: "#avatar-1-j"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M35 47.279l-2.275 4.091-7.053-4.316L27.72 44.1 35 46.786l7.28-2.686 2.047 2.954-7.052 4.316L35 47.28z"
}))));

var SvgAvatar2 = function SvgAvatar2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-2.047ba4fe.svg";
export { ForwardRef as ReactComponent };